import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {
  className?: string;
  color?: string;
}

const ChevronUp: React.FC<Props> = ({ className, color = '#000000' }) => (
  <SVGIcon viewBox="6 -2 30 30" className={className}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill={color} fillRule="nonzero">
        <path d="M33.78125,19.71875 L35.21875,18.28125 L22.71875,5.78125 L22,5.09375 L21.28125,5.78125 L13.6260222,13.4364778 L8.78125,18.28125 L10.21875,19.71875 L22,7.9375 L33.78125,19.71875 Z" />
      </g>
    </g>
  </SVGIcon>
);

export default ChevronUp;
